import { supabase as integratedClient } from "@/integrations/supabase/client";

export const supabase = integratedClient;
// O Supabase está ativo/integrado
export const isSupabaseConfigured = true;